import { SelectUser } from "./selectUser";

export class Admin extends SelectUser{
    password?: string;
    enabled: boolean = true;
    userRole?: string;
}   


 